import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { FileUtilService } from 'src/app/services/file-util.service';
import { LoadingService } from 'src/app/services/loading.service';
import { PersonEventFlagService } from 'src/app/services/person-event-flag.service';
import { TrainingService } from 'src/app/services/training.service';

@Component({
  selector: 'app-training-action-modal',
  templateUrl: './training-action-modal.component.html',
  styleUrls: ['./training-action-modal.component.scss'],
  standalone: false
})
export class TrainingActionModalComponent  {
  @Input() trainingId!: string;

  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Output() addedToCalendar = new EventEmitter();

  @Input() 
  step: 'idd' | 'calendar' = 'calendar';

  constructor(
    private trainingService: TrainingService,
    private personEventFlagService: PersonEventFlagService,
    private fileUtilService: FileUtilService,
    private loadingService: LoadingService,
    private toastrService: ToastrService,
    private translateService: TranslateService,
  ) {}

  shareIddNumber() {
    this.loadingService
    .load(
      this.trainingService.setBrokerIddNumber(this.trainingId)
    ).subscribe(() => {
      this.step = 'calendar';
    });
  }

  skipIddNumber() {
    this.step = 'calendar';
  }

  addToCalendar() {
    this.loadingService
      .load(
        this.personEventFlagService.addPersonEventFlag(
          this.trainingId,
          'AddToCalendar'
        )
      )
      .subscribe(() => {
        this.toastrService.success(
          this.translateService.instant(
            'MY-TRAININGS.SAVED-TO-CALENDAR-SUCCESSFUL'
          )
        );

        this.addedToCalendar.emit();
        this.close();
        this.downloadIcs();
      });
  }

  downloadIcs() {
    this.loadingService
      .load(this.trainingService.getIcs(this.trainingId))
      .subscribe({
        next: (ics) => this.fileUtilService.downloadFile(ics),
        error: () =>
          this.toastrService.error(
            this.translateService.instant('COMMON.AN-ERROR-HAS-OCCURRED')
          ),
      });
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
